exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".license-renderer[data-v-418dc311]{margin-bottom:48px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreements/AgreementRenderer.vue"],"names":[],"mappings":"AACA,mCACE,kBAAoB,CACrB","file":"AgreementRenderer.vue","sourcesContent":["\n.license-renderer[data-v-418dc311] {\n  margin-bottom: 48px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-418dc311","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreements/AgreementRenderer.vue
// module id = 604
// module chunks = 0 1 2 3